/* eslint-disable max-classes-per-file */
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { IDueListPrintRequest } from '../models/due-list-print-request.model';

export class LoadDueListItems {
  static readonly type = '[Due List] Load Due List Items via Service';
  constructor() {}
}

export class LoadMyDueListItems {
  static readonly type = '[Due List] Load My Due List Items via Service';
  constructor() {}
}

export class LoadDueListWarnings {
  static readonly type = '[Due List] Load Due List Warnings via Service';
  constructor(public filter?: MainTableFilterModel) {}
}

export class LoadDueListDueCompetences {
  static readonly type = '[Due List] Load Due List Due Competences via Service';
  constructor(public filter?: MainTableFilterModel) {}
}

export class LoadMyDueListWarnings {
  static readonly type = '[Due List] Load My Due List Warnings via Service';
  constructor(public filter?: MainTableFilterModel) {}
}

export class PrintDueListWarnings {
  static readonly type = '[Due List] Print Due List Warnings';
  constructor(public request?: Partial<IDueListPrintRequest>) {}
}

export class LoadDueListCounts {
  static readonly type = '[Due List] Load Due List Counts';
  constructor() {}
}
